<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters([
      'theme',
    ]),
  },
  mounted() {
    this.initializeTheme();
  },
  methods: {
    initializeTheme() {
      document.documentElement.className = this.theme;
    },
  },

};
</script>

<style>
@import '../node_modules/toastr/build/toastr.css';

html, body, #app {
  margin: 0;
  padding: 0;
  height: 100vh;
  overflow: hidden !important;
}
button, input, select, textarea {
  font-family: inherit;
}
</style>

<style>
  #nprogress .bar {
    background-color: #33a4ca !important;
  }

  #nprogress .spinner {
    color: #33a4ca !important;
  }

  #nprogress .peg {
    box-shadow: 0 0 10px #33a4ca, 0 0 5px #29d !important;
  }
</style>
